import { useState, useCallback } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

import './useConfirmationModalHook.scss';

export default function useConfirmationModal() {
  const [config, setConfig] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const open = useCallback(cfg => {
    setConfig(cfg);
    setIsModalOpen(true);
  }, []);
  const close = useCallback(() => {
    setConfig(null);
    setIsModalOpen(false);
  }, []);

  const getConfirmButtonClass = () => {
    if (config.confirmButtonClass) {
      return config.confirmButtonClass;
    }

    // Default behavior based on buttonType
    switch (config.buttonType) {
      case 'success':
      case 'approve':
        return 'custom-success-btn';
      case 'primary':
        return 'custom-primary-btn';
      case 'warning':
        return 'custom-warning-btn';
      case 'danger':
      case 'delete':
      default:
        return 'custom-danger-btn'; // Default (existing behavior)
    }
  };

  function ConfirmationModal() {
    return config ? (
      <Modal
        isOpen={isModalOpen}
        toggle={close}
        centered
        size="md"
        className="confirm-modal-container"
      >
        <ModalBody className="pb-2" style={{ textWrap: 'nowrap' }}>
          <h5>{config.title}</h5>
          <span>{config.message}</span>
        </ModalBody>
        <ModalFooter className="py-2">
          <div
            className={`w-100 d-flex align-items-center ${config.showCancelButton ? 'gap-2' : 'justify-content-end'} `}
          >
            {config.showCancelButton && (
              <button
                type="button"
                className="custom-light-btn w-100"
                onClick={() => {
                  config.onCancel?.();
                  close();
                }}
              >
                {config.cancelText || 'Cancel'}
              </button>
            )}
            <button
              type="button"
              className={`${getConfirmButtonClass()} w-100`}
              style={{ textWrap: 'nowrap' }}
              onClick={() => {
                config.onConfirm?.();
                close();
              }}
            >
              {config.confirmText || 'Yes, Confirm'}
            </button>
          </div>
        </ModalFooter>
      </Modal>
    ) : null;
  }

  return { open, close, ConfirmationModal, setIsModalOpen };
}
